import React from 'react';
import LegalLayout from './LegalLayout';

const TermsOfService: React.FC = () => {
  return (
    <LegalLayout title="利用規約">
      <section className="space-y-8">
        <div>
          <h2 className="text-lg font-semibold">第１条（適用）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>本利用規約（以下「本規約」とします。）は、株式会社ジーンクエスト（以下「当社」とします。）が提供する「Pishatto」（名称が変更された場合には当該変更後のサービスを含み、以下「本サービス」とします。）の利用についての一切に適用されます。</li>
            <li>当社が利用者に通知する本サービスの説明書、マニュアル、利用上の注意等は、本規約の一部を構成するものとします。</li>
            <li>利用者は、本規約に従って本サービスを利用するものとし、本規約に同意しない限り本サービスを利用することはできないものとします。利用者が本サービスを利用した時点で本規約に同意したものとみなします。</li>
            <li>本サービスの利用者は、発注元と受託者から構成されるものとし、発注元とは本開発等を行っている者を探している者を意味し、受託者とは、本開発等を行っており、本開発等を発注する顧客を探しているもの者を意味します。なお、本契約において「本開発等」とは、システム・スマホアプリ等の全部又は一部の開発、Web制作、保守運用、コンサルティングその他これらに類する取引を意味します。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第２条（本契約の成立及び利用者の情報）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>本規約に基づいて成立する当社と利用者の間の本サービスの利用に関する契約（以下「本契約」といいます。）は、当社が利用者から本サービスの利用申込を受け、当社がこれを承諾したときに成立するものとします。なお、利用者は、当該利用申込の際に、発注元と受託者のどちらの立場で本サービスの利用することを希望するのか明確にするものとし、本契約成立後は、利用申込の際に申し込んだ立場でのみ本サービスを利用することができるものとします。</li>
            <li>当社は、当社の判断により前項の利用申込を承諾しないことができるものとし、かつ、利用申込を承諾しない理由を開示する義務を負わないものとします。</li>
            <li>利用者は、第１項の申込みの際に当社が指定する情報を提供するものとし、本契約成立後に当該情報に変更が生じた場合には、速やかに変更内容を通知するものとします。当社は、当該通知がなされなかったことにより利用者に生じた損害について一切の責任を負いません。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第３条（本規約の変更）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、当社の裁量により、いつでも本規約（第６条に定める料金表を含みます。以下本条において同じ。）の内容を変更できるものとします。変更後の本規約は、当社が別途定める場合を除いて、当社の運営するWebサイト（https://system-dev-navi. com/（理由の如何を問わず、当該Webサイトのドメインが変更された場合の、当該変更後のドメイン等を含みます。）以下「当社ウェブサイト」といいます。）に掲示された時点より効力を生じるものとします。</li>
            <li>利用者が本規約の変更後も本サービスの利用を継続した場合、利用者は、変更後の本規約に同意したものとみなします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第４条（本サービスの利用）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、利用者に対し、本サービスの利用及び管理に使用するID及びパスワードを付与する場合があります。</li>
            <li>利用者は、自己に付与されたID及びパスワードの使用及び管理について一切の責任を負うものとします。当該ID及びパスワードを使用して行われた本サービスの利用は、利用者による利用とみなすものとし、利用者は予めこれを承諾するものとします。</li>
            <li>利用者は、自己に付与されたID及びパスワードを第三者に使用させてはならず、かつ、当該ID及びパスワードについて、譲渡、担保設定その他一切の処分を行ってはならないものとします。</li>
            <li>利用者は、当社から本サービスの提供に必要な資料、情報等の提供その他の対応を求められた場合には速やかにこれに応じるものとします。利用者がかかる資料、情報等の提供その他の対応を怠ったことに起因して当社が本サービスを提供することができなかった場合でも、当社は一切の責任を負わないものとします。</li>
            <li>利用者は、本サービスの利用に関する、設備、機器、ソフトウエア等に要する費用、電気通信回線利用料金等の一切の費用を負担します。</li>
            <li>当社は、利用者に対し、本サービスの利用状況等に関する報告を求めることができるものとし、かかる求めがあった場合、利用者は、速やかに報告を行うものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第５条（マッチング）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>別途当社が定める方法に従い、発注元は受託者の、受託者は発注元の紹介を受けることができるものとします。但し、発注元及び受託者は、場合によっては一社も紹介を受けることができない可能性があることを予め承諾するものとします。</li>
            <li>前項に基づき当社が受託者に発注元を紹介した場合、当該紹介のあった時点で本サービスの利用料金が発生するものとし、受託者は、次条の料金表の定めに従って当社に利用料金を支払う義務を負うものとします。</li>
            <li>第１項の紹介に基づき発注元及び受託者がシステム又はスマホアプリ等の開発に関する契約を締結した場合、発注元及び受託者は、当社の指示に従い、当該契約の内容を当社に報告するものとします。</li>
            <li>第１項の紹介に基づき発注元及び受託者が本開発等に関する契約を締結し、かつ、受託者が発注元に対し当該契約の対価を請求した時点で本サービスの利用料金が発生するものとし、受託者は、次条の料金表の定めに従って当社に利用料金を支払う義務を負うものとします。</li>
            <li>受託者は前項の請求を行った場合、発注元は前項の請求を受けた場合、速やかに当社に請求のあった金額を当社に報告するものとします。</li>
            <li>当社は、第３項又は前項の報告の内容に疑義がある場合又は当該報告が行われていないと合理的に判断する場合、発注元及び受託者に対し、合理的な内容の監査（発注元及び受託者の事業所への立ち入り検査を含みます。）を行うことができるものとし、発注元及び受託者はかかる監査に協力する義務を負うものとします。</li>
            <li>前項の監査によるか否かにかかわらず、発注元及び受託者が第３項又は第５項の報告を怠っていた場合（報告内容が正確でなかった場合を含みます。）、発注元及び受託者は、かかる報告を怠ったことにより支払いが行われていない利用料金の倍額を違約金として当社に支払う義務を負うものとします。本項の規定はかかる違約金の額を超える損害が当社に発生した場合の、当社の発注元及び受託者への賠償義務を妨げるものではありません。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第６条（利用料金）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>利用者は、別途当社が定める料金表に従って、利用料金を支払うものとします。支払に必要な振込手数料その他の費用は、全て利用者の負担とします。</li>
            <li>利用者は、前項の利用料金の支払を怠った場合、年１４．６％の遅延損害金を支払うものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第７条（禁止行為）</h2>
          <p className="mb-2">利用者は、本サービスの利用に際して、以下に定める行為（それらを誘発する行為や準備行為も含みます）を行ってはならないものとします。</p>
          <ol className="list-[upper-alpha] pl-5 space-y-1">
            <li>第５条第４項に定める契約を締結する意思がないにもかかわらず、本サービスを利用する行為</li>
            <li>いわゆるさくら行為を含む、虚偽の情報を本サービス上で投稿、送信等する行為</li>
            <li>利用者に適用される法令、通達、指針、ガイドライン等に違反する行為</li>
            <li>社会規範又は公序良俗に反する行為</li>
            <li>当社、他の利用者又は第三者の権利を侵害する行為</li>
            <li>他の利用者の使用するソフトウエア、ハードウエアなどの機能を破壊したり、妨害したりするようなプログラムなどの投稿などをする行為</li>
            <li>当社のサーバーまたはネットワークの機能を破壊、又は妨害する行為</li>
            <li>本サービスを妨害する行為</li>
            <li>他の利用者の情報を本サービスの利用に必要な範囲を超えて、収集したり蓄積したりする行為</li>
            <li>本サービスを、提供の趣旨に照らして本来のサービス提供の目的とは異なる目的で利用する行為</li>
            <li>他の利用者のID及びパスワードを使用して本サービスを利用する行為</li>
            <li>他の利用者から本サービスのIDやパスワードを入手する行為</li>
            <li>本サービスに関連して、暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団その他これらに準ずるもの（以下総称して「反社会的勢力」といいます。）に直接・間接に利益を提供する行為</li>
            <li>その他当社が禁止する行為</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第８条（中抜き行為の禁止）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>利用者は、本サービスを通じて知った又は知り得た他の利用者との間で、本サービスを利用せず本開発等に関する契約を締結してはならないものとします。</li>
            <li>前項に違反した場合、利用者は、当社に対し、(i)前項に違反して締結された契約が本サービスを利用して行われたとした場合に当社が受領したであろう利用料金の額、(ii)前項の違反が発覚した時点の直近6ヶ月間に当社が当該利用者から受領した利用料金の額、(iii)当該利用者が当該違反行為に基づき他の利用者に支払った金銭の総額、又は（iv）当該利用者が当該違反行為に基づき他の利用者から受領した金銭の総額のいずれかのうち、最も高い金額の倍の金額を、違約金として支払わなければならないものとします。本項の規定は、当社の利用者に対する当該違約金の額を超える損害賠償請求を妨げるものではありません。</li>
            <li>利用者は、他の利用者から第1項に定める契約の締結を持ちかけられた場合、直ちに当該事実を当社に報告するものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第９条（本サービスの終了及び中断）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、当社が適当と判断する方法で利用者に事前に通知することにより、当社の裁量で、本サービスを終了することができるものとします。</li>
            <li>当社は、以下各号の事由が生じた場合には、利用者に事前に通知することなく、本サービスの全部又は一部を一時的に中断することができるものとします。
              <ol className="list-[upper-alpha] pl-5 mt-2 space-y-1">
                <li>本サービスに関するメンテナンスを定期的又は緊急に行う場合</li>
                <li>アクセス過多、その他予期せぬ要因でシステムに負荷が集中した場合</li>
                <li>利用者のセキュリティを確保する必要が生じた場合</li>
                <li>電気通信事業者の役務が提供されない場合</li>
                <li>天災、法令改正等の不可抗力により本サービスの提供が困難な場合</li>
                <li>その他前各号に準じ当社が必要と判断した場合</li>
              </ol>
            </li>
            <li>本条に基づく当社の措置により利用者に発生した一切の損害について、当社は何らの責任も負わないものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１０条（内容及び仕様）</h2>
          <p>当社は、本サービスの内容及び仕様を予告なく変更することがあるものとし、利用者はこれに異議を唱えることができないものとします。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１１条（委託）</h2>
          <p>当社は、当社の裁量により、本サービスに関する業務の全部又は一部を第三者に委託することができるものとします。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１２条（知的財産権）</h2>
          <p>本サービスに関する特許権、著作権、意匠権、実用新案権、商標権等の知的財産権は当社又は権利者である第三者に帰属するものとし、本契約に基づく本サービスの利用の許諾は、本サービスの利用に必要な範囲を超える知的財産権の利用許諾を意味するものではありません。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１３条（責任の制限等）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>本サービスは、発注元と受託者をマッチングするものに過ぎず、当社が発注や本開発等の当事者となるものではないことから、当社は、発注元と受託者の間での契約、紛争その他の事項について一切の責任を負わないものとします。</li>
            <li>本サービスは現状有姿で提供されるものとし、本サービスの各機能は、提供時点において当社が提供可能なものとします。本サービスが利用者の特定の目的に適合すること、期待する機能を有すること、第５条第４項に定める契約の締結その他の期待する成果を実現すること、不具合を起こさないこと及び利用結果を含め、当社は、利用者に対し、本サービスに関する何らの保証も行うものではありません。</li>
            <li>利用者は、自らの費用と責任において、自らのデータのバックアップを行うものとします。当社は、本サービスの利用に伴い、データの消失若しくは破損等が生じた場合であっても、その理由の如何を問わず一切の責任を負うものではありません。</li>
            <li>本サービスに関して利用者と第三者との間に紛争が生じた場合、利用者は自己の責任と費用で解決するものとし、当社に何ら迷惑をかけず、またこれにより当社が被った損害を賠償するものとします。</li>
            <li>利用者は、本サービスの利用が利用者に適用される法令、通達、指針、ガイドライン、業界団体の規則等に違反しないかを自らの費用と責任において確認するものとし、当社は、この点について何らの保証もせず、一切の責任を負わないものとします。</li>
            <li>当社は、本サービスに関して利用者に生じた損害について、当社に故意または重過失が認められる場合に限り責任を負うものとします。なお、いかなる場合でも、本サービスに関連して当社が負う損害賠償義務は、利用者から過去6ヶ月の間に現実に受領した利用料金の額を上限とし、それ以外の損害については一切その責任を負いません。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１４条（第三者サービス）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>本サービスは、当社以外の第三者により運営されるサービス（以下「第三者サービス」といいます。）との連携する場合がありますが、当社は、かかる連携が継続することを保証するものではありません。</li>
            <li>利用者は、自己の責任において、第三者サービスを利用するものとし、第三者サービスの利用により利用者に発生した一切の損害について、当社は何らの責任も負わないものとします。</li>
            <li>第三者サービスの利用は、利用者と第三者サービスの提供者との間に適用される、利用規約、契約等に従うものと、利用者は、自らの責任においてこれらの内容を確認し、順守するものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１５条（秘密保持）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>利用者及び当社は、本規約に関連して相手方から提供された情報のうち、開示の際に秘密である旨の指定があった情報（以下「秘密情報」という。）について、相手方の承諾なく、本サービスの利用及び提供の目的以外に使用してはならず、第三者に開示及び漏洩してはならないものとします。但し、当社は、本条と同等以上の秘密保持義務を負わせることを条件として、第１１条に基づき業務を委託した第三者に秘密情報を開示することができるものとします。</li>
            <li>前項の規定にかかわらず、以下の情報は、秘密情報に含まれないものとします。但し、個人情報については、以下に該当する場合であっても秘密情報に含まれるものとします。
              <ol className="list-[upper-alpha] pl-5 mt-2 space-y-1">
                <li>開示を受けた時点又は知った時点において公知であった情報</li>
                <li>開示を受けた後又は知った後、秘密情報を受領した者の責めに帰すべき事由によらずして公知となった情報</li>
                <li>開示を受けた時点又は知った時点において既に知得していた情報</li>
                <li>正当な権限を有する第三者から知得した情報</li>
                <li>相手方の秘密情報によらずして、創作、開発等した情報</li>
              </ol>
            </li>
            <li>第１項の規定にかかわらず、利用者及び当社は、法律、裁判所又は政府機関の命令、要求又は要請に基づき、秘密情報を開示することができるものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１６条（データ利用）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>利用者は、本サービスの運用、改良、障害対応及びメンテナンス等に必要な範囲内で、当社が、利用者が本サービスの利用に関連して入力又は提供等を行ったデータ（以下「保存データ」という。）にアクセスし、使用することを予め許諾します。</li>
            <li>利用者は、利用者による本サービスの利用に際して当社が利用者から取得する情報（会社情報、会社案内資料、検討資料等を含みますが、これに限られません。）を、当社が受託者と共有すること、その他本サービスの運営、管理、維持、改善等に利用することを予め承諾します。</li>
            <li>当社は、本サービスの運用、改良、障害対応及びメンテナンス等の業務を、当社が選定する第三者に委託する場合があります。この場合、当該業務委託に必要な範囲内で、当該業務委託先が利用者の保存データにアクセスし、使用等する場合があることを利用者は予め許諾します。</li>
            <li>利用者は、本サービスの利用に関連して入力、提供等を行うデータ等について、必要な情報は自己の責任において保全しておくものとします。</li>
            <li>当社は、保存データの保全に努めますが、その全部又は一部が消失しても保存データの復旧その他一切の責任を負いません。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１７条（個人情報）</h2>
          <p>当社は、本サービスに関して利用者から取得した個人情報を、別途定めるプライバシーポリシーに従い取り扱うものとします。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１８条（内容及び仕様）</h2>
          <p>前条の規定にかかわらず、当社は、本契約の終了の前後を問わず、利用者が本サービスを利用したことのある事実を広告宣伝、販売、広報その他の活動に利用することができるものとします。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第１９条（通知）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、本サービスに関連して利用者に通知をする場合には、当社Webサイトに掲示する方法または登録情報として登録された電子メールアドレス・住所に宛てて電子メール・文書を送信する方法など、当社が適当と判断する方法で実施します。</li>
            <li>前項に定める方法により行われた通知は、前者の場合には通知内容が当社ウェブサイトに掲示された時点に、後者の場合は当社が電子メール・文書を発信した時点に、それぞれその効力を生じるものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第２０条（有効期間）</h2>
          <p>本契約の有効期間は、第２条に基づき本契約が成立した日から、当社と利用者間で合意した期間有効に存続するものとします。但し、本サービスが終了した場合には本サービスが終了した時点をもって本契約は終了するものとします。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第２１条（解除）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>利用者及び当社は、相手方に以下の各号の一に該当する事由が発生したときは、直ちに相手方に通知することにより、本契約を解除することができるものとします。但し、第１号については、利用者がこれに該当した場合において、当社のみが解除することができるものとします。
              <ol className="list-[upper-alpha] pl-5 mt-2 space-y-1">
                <li>利用者が第６条に定める利用料金の支払を怠ったとき、又は第７条に定める禁止行為を行ったとき</li>
                <li>前項に定める他、相手方が本規約のいずれかの条項に違反し、当該違反について催告をしたにもかかわらず、相当期間内にこれを是正しないとき</li>
                <li>差押、仮差押、仮処分、租税延滞処分、その他公権力の処分を受けたとき</li>
                <li>破産手続開始、民事再生手続開始、会社更生手続開始、または特別清算開始の申立が行われたとき</li>
                <li>解散（合併の場合を除きます。）あるいは事業の全部を譲渡し、またはその決議がなされたとき</li>
                <li>自ら振り出しもしくは引き受けた手形または小切手が不渡りとなる等支払停止状態に至ったとき</li>
                <li>監督官庁から営業停止、または営業免許もしくは営業登録の取消しの処分を受けたとき</li>
              </ol>
            </li>
            <li>利用者は、本規約に定めがある場合を除き、本契約を解除することはできないものとする。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第２２条（反社会勢力の排除）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>利用者及び当社は、相手方に対し、次の各号に該当しないことを表明保証し、将来にわたり該当しないことを誓約します。
              <ol className="list-[upper-alpha] pl-5 mt-2 space-y-1">
                <li>自ら並びにその親会社、子会社、関連会社、役員及び重要な従業員が、反社会的勢力であること。</li>
                <li>自ら並びにその親会社、子会社、関連会社、役員及び重要な従業員が反社会的勢力と社会的に非難されるべき関係を有すること。</li>
                <li>前二号に該当しなくなったときから５年を経過していないこと。</li>
                <li>自ら又は第三者を利用して、相手方に対し、次に掲げる行為又はこれに準ずる行為を行うこと。
                  <ul className="list-disc pl-5 mt-1 space-y-1">
                    <li>暴力的な要求行為</li>
                    <li>法的な責任を超えた不当な要求行為</li>
                    <li>取引に関して、脅迫的な言動をし、又は暴力を用いる行為</li>
                    <li>風説を流布し、偽計を用い又は威力を用いて、相手方の信用を毀損し、又は相手方の業務を妨害する行為</li>
                  </ul>
                </li>
              </ol>
            </li>
            <li>利用者及び当社は、相手方が前項に違反した場合、本契約を解除することができるものとします。</li>
            <li>前項に基づき本契約を解除した利用者及び当社は相手方に対し、当該解除により相手方に生じたいかなる損害についても責任を負わないものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第２３条（存続条項）</h2>
          <p>本契約が終了した場合でも、第２条第２項及び第３項、第４条第２項から第６項まで、第５条第２項から第７項まで、第６条、第８条、第９条第３項、第１２条から第１９条まで、第２２条第３項、本条、第２４条並びに第２５条までの規定は、有効に存続するものとします。但し、第８条は本契約終了後２年、第１５条は本契約終了後３年に限り、有効に存続するものとします。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第２４条（権利義務の譲渡）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>利用者は、当社の事前の承諾がある場合を除き、本契約に基づく利用者の権利若しくは義務、又は本契約上の地位について、第三者への譲渡、承継、担保設定、その他一切の処分をすることはできません。</li>
            <li>当社が、本サービスに関する事業を第三者に譲渡したときは、当社は、当該事業譲渡に伴い、本契約上の地位、権利及び義務並びに利用者に関する一切の情報を当該事業譲渡の譲受人に譲渡することができるものとし、利用者は、予めこれに同意するものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">第２５条（準拠法及び裁判管轄）</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>本規約の解釈および適用にあたっては、日本法が適用されるものとします。</li>
            <li>本規約に関する一切の紛争については、東京地方裁判所を第一審専属的合意管轄裁判所とします。</li>
          </ol>
        </div>
      </section>
    </LegalLayout>
  );
};

export default TermsOfService;

